const EDITABLE_ARTICLE_FIELDS = [
  'title',
  'excerpt',
  'content',
  'category',
  'author',
  'image_url',
  'published',
];

export const hasMeaningfulArticleContent = (content) => {
  if (typeof content !== 'string') return false;
  const text = content
    .replace(/<(br|hr)\b[^>]*\/?\s*>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;|&#160;/gi, ' ')
    .replace(/&[a-z0-9#]+;/gi, 'x')
    .trim();
  return text.length > 0;
};

export const getArticleContentState = ({ isExistingArticle, contentLoaded, content }) => {
  if (isExistingArticle && !contentLoaded) return 'not-loaded';
  if (!hasMeaningfulArticleContent(content)) return 'loaded-empty';
  return 'loaded';
};

export const canSaveArticle = ({ title, excerpt, content, isExistingArticle, contentLoaded }) => (
  typeof title === 'string'
  && title.trim().length > 0
  && typeof excerpt === 'string'
  && excerpt.trim().length > 0
  && getArticleContentState({ isExistingArticle, contentLoaded, content }) === 'loaded'
);

export const buildArticlePatch = (original, current) => {
  const patch = {};
  EDITABLE_ARTICLE_FIELDS.forEach((field) => {
    if (current[field] === original[field]) return;
    const value = current[field];
    patch[field] = typeof value === 'string' && field !== 'content'
      ? value.trim()
      : value;
  });
  return patch;
};

export const normalizeNewArticle = (article) => ({
  title: article.title.trim(),
  excerpt: article.excerpt.trim(),
  content: article.content,
  category: article.category.trim() || 'Santé',
  author: article.author.trim() || 'Centre Médical la Trinité',
  image_url: (article.image_url || '').trim(),
  published: !!article.published,
});